import React from 'react'

const mainpic = "https://images.squarespace-cdn.com/content/v1/6509b098e9ec677d0862ff32/1ee1598d-39b7-4a7b-bb68-d7b0bf052faa/DSCF8256.jpg?format=750w"


function CEO() {
  return (
    <div>
     <section class="p-8">
  <div class="mx-auto max-w-screen-md">
    <img
      src={mainpic}
      alt="team work"
      class="mb-4 h-[28rem] w-full rounded-xl object-cover"
    />
    <p
      class="block antialiased font-sans text-sm font-light leading-normal text-inherit font-medium !text-blue-500"
    >
      #FOKMH #CEO
    </p>
    <h2
      class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-[1.3]  my-4 text-[#3ea498] text-2xl !leading-snug"
    >
      Message from Co-Founder and Executive President
    </h2>

    <h3 className='mb-2 text-xl text-gray-700'>My Story with Karanda Mission Hospital</h3>
    <p
      class="block antialiased font-sans text-base font-light leading-relaxed text-inherit font-normal !text-gray-700"
    >
      My journey with Karanda Mission Hospital began when I was introduced to Dr. James Watt by my elder sister, who had arrived in Canada earlier. Dr. Watt, a former missionary and medical doctor at Howard Mission in Chiweshe, Zimbabwe for over thirty years, lives just two blocks away from my sister's place. We engage in conversations on various aspects of our homeland, including its politics, social, and economic issues.<br />
      
      <br />One day, during one of our heartfelt discussions, I opened up to Dr. Watt about the devastating impact cancer has on families. I shared how this cruel disease causes immense suffering for patients and leaves their families with enormous medical bills, especially when it is the breadwinner who is affected and eventually passes away.
My personal experiences with cancer have deeply shaped my perspective. My father, Weston Matsveru Mutepfa, died of liver cancer when I was only 14 years old. His death in 1985, at the age of 57, was a tremendous loss for me as the youngest of seven siblings. Thankfully, my older siblings took care of me and our mother after his passing.

      
      <br /><br />
      
      In 1997, our family faced another blow when we lost my eldest brother, Weston Taremeredzwa Mutepfa, to colon cancer at the age of 45. His death devastated our entire family, including his wife and five children.
More recently, on November 17, 2022, I lost another dear brother, Tonderai Blessing Mutepfa, to a brain tumor. He was only 41 years old, and his passing was a shock to us all. 

<br /><br />
Tonderai underwent two major brain surgeries, and the huge medical expenses took a toll on his family. Witnessing his pain and the financial strain revealed to me the urgent need for support during such trying times. I often think of those less privileged who endure similar hardships without any help.
In 2023, I lost a close friend and former schoolmate, Shorai Makatare, to colon cancer. Fundraising for Tonderai and Shorai through GoFundMe to assist with their medical expenses was incredibly challenging. When even close family members are unable to help due to financial constraints, the situation becomes even more dire.

<br /><br />
Sharing these experiences with Dr. Watt, I expressed my desire to help fellow Zimbabweans facing similar struggles, not just among friends and family, but for the broader community. Dr. Watt introduced me to Dr. Paul Thistle, the Medical Superintendent of Karanda Mission Hospital, whom I visited in August 2023. During our discussions, I shared my vision of working with a mission hospital like Karanda to mobilize global resources.

<br /><br />
Dr. Paul Thistle welcomed the idea and suggested founding "Friends of Karanda Mission Hospital." A friend, Rufaro Mucheri, also supported the initiative, offering technical assistance in web design and construction.
Today, a global board of volunteers has been formed to outreach and fundraise for Karanda Mission Hospital. We appeal to Zimbabweans and other nationals to support the birth of the Karanda Cancer Center. Your support and generosity can give someone a new lease on life. Join us in supporting the Karanda Mission Hospital Cancer Center through our “Adopt a Patient” appeal.

    </p>
  </div>
</section>
    </div>
  )
}

export default CEO
